export default "__VITE_ASSET__CO_id2Cs__"